/* 布局 */
//前台
import Layout from "@views/layout";

const goodsetiquetteRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "goodsetiquette/list",
        name: "GOODSETIQUETTE",
        meta: {
            title: "礼仪套餐管理",
            keepAlive:true
        },
        component: () => import("@views/business/goodsetiquette/index.vue"),
    },
        ],
};

export default goodsetiquetteRouter;
